/**
 * Impact & Metrics Translations Module (French)
 * 
 * Contains: YFI Formula, YFI Rankings, Performance KPIs, Advanced Metrics, Engagement Metrics
 * 
 * @module impact
 * @language fr
 */

export const impact = {
  impactMetrics: {
    pageTitle: "Impact et Métriques",
    pageSubtitle: "Mesurer le Leadership des Jeunes, la Santé Mentale et les Opportunités Économiques dans 114 pays JCI"
  },
  fiiFormula: {
    stats: {
      mentalDisorders: "1 sur 7 affectés par des troubles mentaux",
      mentalHealthLimiting: "68% citent la santé mentale comme limitante",
      emergingAccess: "Marchés émergents (10-30% accès)",
      digitalSkillsGap: "92% des emplois nécessitent compétences numériques (seulement 30% formés)",
      youthVsAdult: "13% jeunesse mondiale (vs 4.9% adultes)",
      neetCrisis: "256M jeunes (20.4%) pas en éducation/travail",
      ssaAspiration: "52% des jeunes Afrique Subsaharienne veulent lancer une entreprise",
      fundingGap: "Seulement 3% obtiennent financement (écart $1.7T mondial)",
      womenGap: "Femmes entrepreneures 35% sous-représentées"
    },
    reasoning: {
      mentalHealth: "Pondération élevée reflète importance fondamentale - santé mentale permet autres capacités",
      workforce: "Pondération significative reflète emploi comme porte vers indépendance économique",
      entrepreneurship: "Pondération significative reflète potentiel innovation et nécessité auto-emploi"
    },
    mentalHealthStat1: "1 sur 7 affectés par des troubles mentaux",
    mentalHealthStat2: "68% citent la santé mentale comme limitante",
    mentalHealthStat3: "Marchés émergents (10-30% accès)",
    workforceStat1: "92% des emplois nécessitent compétences numériques (seulement 30% formés)",
    workforceStat2: "13% chômage jeunesse mondiale (vs 4.9% adultes)",
    workforceStat3: "256M jeunes (20.4%) pas en éducation/travail",
    entrepreneurshipStat1: "52% des jeunes Afrique Subsaharienne veulent lancer une entreprise",
    entrepreneurshipStat2: "Seulement 3% obtiennent financement (écart $1.7T mondial)",
    entrepreneurshipStat3: "Femmes entrepreneures 35% sous-représentées",
    mentalHealthReasoning: "Pondération élevée reflète importance fondamentale - santé mentale permet autres capacités",
    workforceReasoning: "Pondération significative reflète emploi comme porte vers indépendance économique",
    entrepreneurshipReasoning: "Pondération significative reflète potentiel innovation et nécessité auto-emploi"
  },
  engagement: {
    title: "Métriques d'Engagement",
    subtitle: "Analyse de participation et activité des membres",
    eventParticipation: "Participation aux Événements",
    volunteerHours: "Heures de Bénévolat",
    projectContributions: "Contributions aux Projets",
    monthlyActiveUsers: "Utilisateurs Actifs Mensuels"
  },
  network: {
    title: "Analyse du Réseau",
    subtitle: "Connexions globales et modèles de collaboration",
    totalConnections: "Connexions Totales",
    activeProjects: "Projets Actifs",
    strategicPartnerships: "Partenariats Stratégiques",
    knowledgeTransfer: "Transfert de Connaissances",
    collectiveImpact: "Impact Collectif",
    progress: "Progrès",
    target: "Cible"
  },
  trends: {
    title: "Analyse des Tendances et Prédictions",
    subtitle: "Évolution historique de JCI et projections basées sur IA pour 2026-2030",
    historical: "Évolution Historique (2015-2025)",
    predictions: "Projections 2026-2030",
    confidence: "confiance",
    keyTrends: "Tendances Clés Identifiées",
    sustainedGrowth: "Croissance Soutenue",
    digitalRevolution: "Révolution Numérique",
    wellbeingFocus: "Focus Bien-être",
    sustainability: "Durabilité",
    seasonalPatterns: "Modèles Saisonniers",
    enrollments: "Inscriptions",
    projects: "Projets",
    events: "Événements",
    members: "Membres",
    countries: "Pays",
    imh: "ISM"
  },
  status: {
    strong: "Fort",
    growing: "Croissant",
    expanding: "En Expansion",
    stable: "Stable",
    emerging: "Émergent",
    active: "Actif",
    expansion: "Expansion",
    pilot: "Pilote",
    beta: "Bêta"
  },
  advancedMetrics: {
    title: "Métriques Avancées",
    subtitle: "Analyse détaillée de performance, conversion et indicateurs clés pour Vision 2040",
    conversionFunnel: "Entonnoir de Conversion",
    websiteVisitors: "Visiteurs du Site",
    interested: "Intéressés",
    candidates: "Candidats",
    interviewed: "Interviewés",
    activeMembers: "Membres Actifs",
    totalConversionRate: "Taux de Conversion Total",
    costPerAcquisition: "Coût par Acquisition",
    programROI: "ROI du Programme",
    performanceTrends: "Tendances de Performance",
    members: "Membres",
    countries: "Pays",
    programs: "Programmes",
    keyPerformanceIndicators: "Indicateurs Clés de Performance",
    retentionRate: "Taux de Rétention",
    membersActive12Months: "Membres actifs depuis 12+ mois",
    digitalEngagement: "Engagement Numérique",
    onlineEventParticipation: "Participation aux événements en ligne",
    memberSatisfaction: "Satisfaction des Membres",
    avgProgramEvaluation: "Évaluation moyenne des programmes",
    averageLeadershipTime: "Temps de Leadership Moyen",
    joiningToFirstLeadership: "De l'adhésion à la première position de leadership",
    target: "Cible",
    progress: "Progrès"
  },
  performanceKPIs: {
    title: "KPIs de Performance",
    subtitle: "Indicateurs clés de performance et objectifs pour 2025",
    updatedAgo: "Mis à jour",
    memberRetentionRate: "Taux de Rétention des Membres",
    annualRetentionVsTarget: "Rétention annuelle des membres vs cible",
    programROI: "ROI du Programme",
    trainingProgramsROI: "Retour sur investissement pour programmes de formation",
    newMarkets: "Nouveaux Marchés",
    newCountriesEntered: "Nouveaux pays entrés cette année",
    communityImpactScore: "Score d'Impact Communautaire",
    aggregateCommunityImpact: "Mesure d'impact communautaire agrégé",
    memberEngagement: "Engagement des Membres",
    activeParticipationJCI: "Participation active aux activités JCI",
    leadershipPipeline: "Pipeline de Leadership",
    membersInLeadershipTrack: "Membres dans parcours de développement leadership",
    performance: "performance",
    growth: "croissance",
    impact: "impact",
    engagement: "engagement",
    target: "Cible"
  },
  aiInsights: {
    title: "Centre d'Insights IA",
    subtitle: "Analytique prédictive, recommandations stratégiques et scénarios hypothétiques pour décisions intelligentes",
    aiChat: "Chat IA",
    recommendations: "Recommandations",
    insights: "Insights",
    whatIf: "Et-Si",
    jciAssistant: "Assistant Intelligent JCI",
    askAboutData: "Posez des questions sur données, tendances et stratégies",
    askPlaceholder: "Demandez sur tendances, analyses ou stratégies...",
    greeting: "Bonjour! Je suis l'assistant insights JCI. Comment puis-je vous aider à analyser données et découvrir opportunités stratégiques?",
    analyzing: "Analyse de votre question sur",
    growthPotential: "potentiel de croissance sur les 18 prochains mois",
    priority: "Priorité",
    confidence: "Confiance",
    viewDetails: "Voir Détails",
    expectedImpact: "Impact Attendu",
    estimatedTime: "Temps estimé",
    simulateScenario: "Simuler Scénario",
    strategicExpansion: "Expansion Stratégique en Amérique Latine",
    strategicExpansionDesc: "Les données indiquent 40% de potentiel de croissance inexploré dans pays comme Colombie et Pérou.",
    digitalMentalHealth: "Programme Numérique de Santé Mentale",
    digitalMentalHealthDesc: "Implémenter plateforme numérique augmenterait engagement de 60% dans communautés jeunes.",
    techPartnerships: "Partenariats Technologiques",
    techPartnershipsDesc: "Intégration avec startups locales pourrait accélérer programmes d'innovation de 45%.",
    growth: "Croissance",
    wellbeing: "Bien-être",
    innovation: "Innovation",
    millennialEngagement: "Engagement Millennials",
    millennialEngagementDesc: "Croissance accélérée dans participation des 25-30 ans",
    sustainableProjects: "Projets Durables",
    sustainableProjectsDesc: "Initiatives ESG ont montré ROI supérieur",
    regionalRetention: "Rétention Régionale",
    regionalRetentionDesc: "Certaines régions nécessitent attention spéciale",
    whatIfLeadership: "Et si nous augmentions investissement dans programmes leadership de 25%?",
    whatIfLeadershipImpact: "35% augmentation qualité leadership, 2.3x plus participation événements",
    whatIfAI: "Et si nous implémentions IA dans tous processus administratifs?",
    whatIfAIImpact: "40% réduction temps administratif, $2.1M économies annuelles",
    budget: "Budget",
    months: "mois",
    focusYoungLeaders: "Focus sur jeunes leaders",
    totalAutomation: "Automatisation totale",
    training: "Formation",
    gradualMigration: "Migration graduelle"
  },
  homeGlobalPresence: {
    title: "Présence Mondiale JCI",
    subtitle: "Actifs dans 114 pays à travers 4 régions",
    regions: "Régions",
    countries: "Pays",
    members: "Membres",
    localOrgs: "Orgs Locales"
  },
  fii: {
    title: "Indice des Futurs de la Jeunesse (YFI)",
    measuringYouthOpportunity: "Mesurer les Opportunités des Jeunes dans 114 Pays",
    scale: "Échelle: 0-100 (Plus élevé = Meilleure Opportunité Jeunesse)",
    mentalHealth: "Santé Mentale",
    workforceEducation: "Main-d'œuvre et Éducation",
    entrepreneurshipSupport: "Soutien à l'Entrepreneuriat",
    mentalHealthQuote: "La santé mentale est le fondement sur lequel toutes les autres capacités sont construites.",
    workforceQuote: "L'emploi est la porte d'entrée vers l'indépendance économique.",
    entrepreneurshipQuote: "L'innovation et l'auto-emploi sont des voies essentielles pour les opportunités des jeunes.",
    globalCrisis: "Crise Mondiale",
    employmentBarrier: "Barrière à l'Emploi",
    mostVulnerable: "Plus Vulnérables",
    skillGap: "Écart de Compétences",
    unemployment: "Chômage des Jeunes",
    neetCrisis: "Crise NEET",
    aspiration: "Aspiration Entrepreneuriale",
    fundingGap: "Écart de Financement",
    genderGap: "Écart de Genre",
    whyThisWeighting: "Pourquoi Cette Pondération?",
    ofTotalScore: "du score total",
    weight: "Poids",
    source: "Source",
    indicators: "Indicateurs",
    countriesMeasured: "Pays Mesurés",
    jciNationalOrgs: "Orgs Nationales JCI",
    completeData: "Données Complètes",
    countries: "pays",
    averageFII: "YFI Moyen",
    highest: "Plus Élevé",
    lowest: "Plus Bas",
    pointRange: "Plage de Points",
    countriesRanked: "Pays Classés",
    excellent: "Excellent",
    good: "Bon",
    moderate: "Modéré",
    deficient: "Déficient",
    challenges: "Défis",
    critical: "Critique",
    globalRankings: "Indice Mondial YFI",
    searchCountry: "Rechercher un pays...",
    allRegions: "Toutes les Régions",
    rank: "Rang",
    country: "Pays",
    region: "Région",
    score: "Score",
    classification: "Classification",
    
    // Component Breakdown & Benchmarks
    componentBreakdown: "Répartition par Composant",
    vsBenchmarks: "vs Références",
    vsGlobalAvg: "vs Moyenne Mondiale",
    globalAverage: "Moyenne Mondiale",
    data: "Données",
    complete: "Complet",
    limited: "Limité",
    
    // Legend labels
    legendGood: "Bon",
    legendModerate: "Modéré",
    legendChallenges: "Défis",
    legendCritical: "Critique",
    
    useFIIData: "Utiliser les Données YFI",
    useFIIDataDesc: "Téléchargez les données de l'indice et la documentation méthodologique pour la recherche et le plaidoyer",
    exportRankings: "Exporter l'Indice (CSV)",
    downloadMethodology: "Télécharger la Méthodologie (PDF)",
    comingSoon: "Bientôt Disponible",
    methodologyComingSoon: "PDF de méthodologie bientôt disponible",
    researchCitations: "Citations de Recherche",
    sourceWhoDescription: "Accès aux services de santé mentale, lacunes de traitement, couverture des politiques",
    sourceIloDescription: "Chômage des jeunes, taux de NEET, qualité de la main-d'œuvre",
    sourceGemDescription: "Entrepreneuriat en phase initiale, environnement des affaires",
    sourceWorldBankDescription: "Données de soutien pour la dimension entrepreneuriale",
    aboutMethodology: "À Propos de la Méthodologie",
    aboutMethodologyDesc: "Le YFI utilise des données vérifiées de l'OMS, l'OIT, la Banque Mondiale et d'autres sources autorisées.",
    howToCite: "Comment Citer",
    citationText: "JCI Development Councils Youth Futures Observatory (2025). Indice des Futurs de la Jeunesse.",
    insightsTitle: "Perspectives Stratégiques",
    insightsSubtitle: "Principales conclusions de l'analyse YFI",
    finding: "Constatation",
    dataEvidence: "Preuve de Données",
    implication: "Implication",
    actionForJCI: "Action pour JCI",
    insight1Title: "Santé Mentale comme Fondation",
    insight2Title: "Inadéquation Compétences-Emploi",
    insight3Title: "Disparités Régionales",
    insight4Title: "Paradoxe de l'Entrepreneuriat",
    insight5Title: "Écarts de Genre Persistent",
    dataVintage: "Période des Données",
    dataVintageDesc: "Données 2023-2024 de sources internationales vérifiées",
    methodologyTitle: "Méthodologie YFI",
    methodologySubtitle: "Comment nous calculons l'Indice d'Impact Futur",
    formulaExplanation: "Explication de la Formule",
    pillarWeights: "Poids des Piliers",
    dataSourcesTitle: "Sources de Données",
    calculationFormula: "Formule de Calcul",
    threeDimensions: "Les Trois Dimensions",
    officialDataSources: "Sources de Données Officielles",
    dataCoverage: "Couverture des Données",
    dataCoverageDesc: "Le YFI couvre 114 pays membres de JCI. La disponibilité des données varie par pays et indicateur.",
    openData: "Données Ouvertes",
    openDataDesc: "Toutes les données sources sont publiquement disponibles auprès d'institutions autorisées.",
    zeroSynthetic: "Zéro Données Synthétiques",
    zeroSyntheticDesc: "Nous utilisons uniquement des données réelles et vérifiées - jamais de valeurs générées par IA ou estimées.",
    fullTransparency: "Transparence Totale",
    fullTransparencyDesc: "La méthodologie complète et les calculs sont documentés publiquement.",
    scientificRigor: "Rigueur Scientifique",
    scientificRigorDesc: "Méthodologie examinée et validée par des partenaires de recherche.",
    regionalPerformance: "Performance Régionale",
    topPerformers: "Meilleurs Résultats",
    bottomPerformers: "Résultats les Plus Bas",
    keyTakeaways: "Points Clés"
  },
  globalFIIMap: {
    title: "Carte Mondiale YFI",
    subtitle: "Explorez les métriques d'opportunité jeunesse dans tous les pays JCI",
    jciCountries: "Pays JCI",
    totalMembers: "Membres Totaux",
    completeData: "Données Complètes",
    globalRegions: "Régions Mondiales",
    regionalOverview: "Aperçu Régional",
    countries: "Pays",
    avgFII: "YFI Moyen",
    leader: "Leader",
    searchCountry: "Rechercher un pays...",
    allRegions: "Toutes les Régions",
    allClassifications: "Toutes les Classifications",
    regionAsiaPacific: "Asie et le Pacifique",
    regionEurope: "Europe",
    regionAmericas: "Amérique",
    regionAfricaMe: "Afrique et Moyen-Orient",
    excellent: "Excellent",
    good: "Bon",
    moderate: "Modéré",
    deficient: "Déficient",
    critical: "Critique",
    countriesTotal: "Total des Pays",
    matching: "correspondant",
    fiiDataset: "Dataset YFI",
    withCompleteData: "avec données complètes",
    limitedData: "Données Limitées",
    members: "membres"
  },
  fiiInsights: {
    insight: "Insight",
    sourceAttribution: "Rapport d'Impact JCI 2025 | Analyse Régionale YFI 2024",
    priority: {
      critical: "Critique",
      high: "Élevé",
      medium: "Moyen"
    },
    mentalHealth: {
      finding: "La santé mentale est le meilleur prédicteur du score YFI global. Les pays avec des scores de santé mentale élevés se classent systématiquement mieux.",
      mhScoreVariation: "Variation du Score SM",
      wfEtScoreVariation: "Variation des Scores MO & Ent",
      potentialImprovement: "Amélioration Potentielle du YFI",
      implication: "Investir dans la santé mentale génère le meilleur retour sur l'opportunité jeunesse globale.",
      action: "Prioriser les programmes de santé mentale dans les initiatives JCI, surtout dans les régions à faible score."
    },
    skillsMismatch: {
      finding: "Malgré une forte inscription éducative, le chômage des jeunes reste élevé en raison de l'inadéquation des compétences.",
      youthInEducation: "Jeunes en Éducation",
      youthUnemployment: "Taux de Chômage des Jeunes",
      neetPopulation: "Population NEET",
      digitalSkillsJobs: "Emplois Nécessitant des Compétences Numériques",
      implication: "L'éducation traditionnelle ne prépare pas les jeunes à la main-d'œuvre moderne.",
      action: "Développer des programmes de formation basés sur les compétences axés sur les compétences numériques et entrepreneuriales."
    },
    regionalDisparities: {
      finding: "Des écarts significatifs existent entre les régions, l'Afrique-Moyen Orient faisant face aux plus grands défis.",
      mentalHealthGap: "Écart de Santé Mentale (Europe vs Afrique-MO)",
      workforceGap: "Écart de Main-d'œuvre",
      entrepreneurshipGap: "Écart d'Entrepreneuriat",
      implication: "Une approche unique ne fonctionnera pas; des stratégies régionales sont nécessaires.",
      action: "Développer des programmes spécifiques par région et augmenter l'allocation de ressources aux zones mal desservies."
    },
    entrepreneurship: {
      finding: "Une forte aspiration entrepreneuriale existe dans les régions en développement mais l'accès au capital est sévèrement limité.",
      ssaRate: "Taux d'Entrepreneuriat en ASS",
      financingGap: "Écart de Financement Mondial",
      africaMeShare: "Part Afrique-MO dans les Startups Mondiales",
      youthWanting: "Jeunes Voulant Créer une Entreprise",
      implication: "Un potentiel entrepreneurial inexploité existe, contraint par l'accès au financement.",
      action: "Créer des programmes de microfinancement et connecter les jeunes entrepreneurs avec des investisseurs."
    },
    gender: {
      finding: "Les femmes font face à des désavantages cumulés dans les trois dimensions du YFI.",
      depressionRates: "Taux de Dépression des Femmes",
      womenUnemployment: "Chômage des Femmes",
      neetWomen: "Part des Femmes dans NEET",
      womenLedStartups: "Startups Dirigées par des Femmes",
      vcToWomen: "Financement VC pour les Femmes",
      implication: "Les barrières spécifiques au genre nécessitent des interventions ciblées.",
      action: "Lancer des programmes de leadership et d'entrepreneuriat axés sur les femmes."
    }
  },
  fiiMethodology: {
    formulaExplanation: "Le YFI est calculé comme une moyenne pondérée de trois dimensions: Santé Mentale (40%), Main-d'œuvre et Éducation (30%), et Soutien à l'Entrepreneuriat (30%).",
    mentalHealth: {
      description: "Mesure le bien-être mental des jeunes, l'accès aux services de santé mentale et le bien-être psychologique global."
    },
    workforce: {
      description: "Évalue les taux d'emploi des jeunes, la qualité de l'éducation, le développement des compétences et l'accès au marché du travail."
    },
    entrepreneurship: {
      description: "Évalue l'environnement des affaires, l'accès au financement, l'infrastructure numérique et l'écosystème des startups."
    },
    indicators: {
      mentalDisorderPrevalence: "Prévalence des Troubles Mentaux",
      youthSuicideRate: "Taux de Suicide des Jeunes",
      mentalHealthServiceAccess: "Accès aux Services de Santé Mentale",
      mentalWellbeingIndex: "Indice de Bien-être Mental",
      youthUnemploymentRate: "Taux de Chômage des Jeunes",
      neetRate: "Taux NEET",
      tertiaryEducation: "Inscription dans l'Enseignement Supérieur",
      humanCapitalIndex: "Indice de Capital Humain",
      easeOfDoingBusiness: "Facilité de Faire des Affaires",
      totalEntrepreneurialActivity: "Activité Entrepreneuriale Totale",
      accessToFinancing: "Accès au Financement",
      digitalInfrastructure: "Infrastructure Numérique"
    },
    dataTypes: {
      education: "Éducation",
      multiDimensional: "Multidimensionnel",
      wellbeing: "Bien-être",
      digitalInfrastructure: "Infrastructure Numérique"
    },
    access: {
      publicApiDownloads: "API Publique et Téléchargements",
      ilostatPublicApi: "API Publique ILOSTAT",
      publicDataPortal: "Portail de Données Publiques",
      freeApiAccess: "Accès API Gratuit",
      publicReports: "Rapports Publics",
      publicData: "Données Publiques",
      annualPublicRelease: "Publication Publique Annuelle",
      publicStatistics: "Statistiques Publiques"
    }
  }
} as const;
